(function () {
  const STORAGE_KEY = 'pure67Wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateAllWishlistButtons();
    updateWishlistCounter();
    renderWishlistPage();
  }

  function normalizeProduct(product) {
    return {
      handle: product.handle || '',
      title: product.title || '',
      url: product.url || '',
      image: product.image || '',
      price: product.price || '',
      compareAtPrice: product.compareAtPrice || ''
    };
  }

  function isWishlisted(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function addWishlist(product) {
    const list = getWishlist();
    const normalized = normalizeProduct(product);

    if (!normalized.handle) return;

    if (!list.some(item => item.handle === normalized.handle)) {
      list.push(normalized);
      saveWishlist(list);
    }
  }

  function removeWishlist(handle) {
    const list = getWishlist().filter(item => item.handle !== handle);
    saveWishlist(list);
  }

  function toggleWishlist(product) {
    if (!product || !product.handle) return;

    if (isWishlisted(product.handle)) {
      removeWishlist(product.handle);
    } else {
      addWishlist(product);
    }
  }

  function updateAllWishlistButtons() {
    const buttons = document.querySelectorAll('[data-p67-wishlist-button]');

    buttons.forEach(button => {
      const handle = button.dataset.productHandle;
      const active = isWishlisted(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const icon = button.querySelector('.p67-wishlist-icon');
      if (icon) {
        icon.classList.toggle('is-active', active);
      }
    });
  }

  function updateWishlistCounter() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-p67-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function renderWishlistPage() {
    const container = document.querySelector('[data-p67-wishlist-grid]');
    if (!container) return;

    const list = getWishlist();

    if (!list.length) {
      container.innerHTML = `
        <div class="p67-wishlist-empty">
          <div class="p67-wishlist-empty__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          </div>

          <h2>No tienes favoritos todavía</h2>

          <p>
            Guarda tus prendas favoritas y vuelve a encontrarlas aquí cuando quieras.
          </p>

          <a href="/collections/all" class="p67-wishlist-empty__button">
            Ver productos
          </a>
        </div>
      `;
      return;
    }

    container.innerHTML = list.map(item => `
      <article class="p67-wishlist-card" data-wishlist-card="${item.handle}">

        <div class="p67-wishlist-card__image-wrap">

          <a href="${item.url}" class="p67-wishlist-card__image-link">

            ${
              item.image
                ? `<img
                    src="${item.image}"
                    alt="${escapeHtml(item.title)}"
                    class="p67-wishlist-card__image"
                    loading="lazy"
                  >`
                : `<div class="p67-wishlist-card__image-placeholder"></div>`
            }

          </a>

          <button
            type="button"
            class="p67-wishlist-card__remove"
            data-p67-remove-wishlist="${item.handle}"
            aria-label="Eliminar ${escapeHtml(item.title)} de favoritos"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M18 6L6 18"></path>
              <path d="M6 6l12 12"></path>
            </svg>
          </button>

        </div>

        <div class="p67-wishlist-card__content">

          <a href="${item.url}" class="p67-wishlist-card__title">
            ${escapeHtml(item.title)}
          </a>

          <div class="p67-wishlist-card__price">
            ${item.price || ''}
          </div>

        </div>

      </article>
    `).join('');

    container.querySelectorAll('[data-p67-remove-wishlist]').forEach(button => {
      button.addEventListener('click', () => {
        removeWishlist(button.dataset.p67RemoveWishlist);
      });
    });
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-p67-wishlist-button]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleWishlist({
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      compareAtPrice: button.dataset.productComparePrice
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateAllWishlistButtons();
    updateWishlistCounter();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    updateAllWishlistButtons();
    updateWishlistCounter();
    renderWishlistPage();
  });

  window.PURE67Wishlist = {
    get: getWishlist,
    add: addWishlist,
    remove: removeWishlist,
    toggle: toggleWishlist,
    render: renderWishlistPage
  };
})();